import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

export default function Hero() {
  return (
    <div className="w-full bg-black max-h-[800px] ">
      <div className="text-center">
        <div>
          <StaticImage src="../../../images/hero/hero.png" alt="" />
        </div>
        <div className="hidden">
          <StaticImage src="../../../images/hero/hero.png" alt="" />
        </div>
      </div>
    </div>
  )
}
